import useCountUp from '@/hooks/useCountUp';
import useInView from '@/hooks/useInView';
import { stats } from '@/mocks/home';

function StatCard({
  value,
  prefix,
  suffix,
  label,
  decimals,
  start,
}: {
  value: number;
  prefix: string;
  suffix: string;
  label: string;
  decimals: number;
  start: boolean;
}) {
  const current = useCountUp(value, start, 1600, decimals);
  return (
    <div className="rounded-xl border border-white/8 bg-background-100/60 p-6 text-center">
      <p className="font-heading font-extrabold text-3xl md:text-4xl text-primary-400">
        {prefix}
        {current}
        {suffix}
      </p>
      <p className="mt-2 text-sm text-foreground-600">{label}</p>
    </div>
  );
}

export default function StatsStrip() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section className="relative py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div ref={ref} className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map((s) => (
            <StatCard
              key={s.label}
              value={s.value}
              prefix={s.prefix}
              suffix={s.suffix}
              label={s.label}
              decimals={s.decimals}
              start={inView}
            />
          ))}
        </div>
      </div>
    </section>
  );
}